export default __webpack_public_path__ + "static/media/mysql.4c509260.svg";